<div class="notification-list-header">
  <div class="header-container">
    <span class="icon icon-Pagination-Arrow-1" (click)="hideNotifications()"></span>
    <span class="header-title">Notifications</span>
    <div class="header-actions">
      @if (haveUnreadNotifications()) {
        <span class="read-all-action" (click)="readAllUnread()">Mark all as read</span>
      }
      <!--            <span class="icon icon-Settings"></span>-->
    </div>
  </div>
  <div class="horizontal-separator"></div>
</div>
<div class="notification-list">
  @for ( notificationGroup of groupedNotification(); track  notificationGroup) {
    <div class="group">
      <div class="group-title">{{convertGroupDate(notificationGroup.date)}}</div>
      @for (notification of notificationGroup.notifications; track notification) {
        <div class="notification-row">
          <div class="notification-body">
            <div class="notification-icon">
              <div class="notification-type" [innerHTML]="getCategoryType(notification)"></div>
              <div class="notification-sub-category">
                <inline-svg [src]="getSubCategoryType(notification)+'.svg'" className="category-icon"
                ></inline-svg>
              </div>
            </div>
            <div class="notification-info">
              <span [innerHTML]="notificationMsgTransform(notification.message)"></span>
              <span>{{convertDate(notification.created_at)}}</span>
            </div>
          </div>
          <div class="read-indicator">
            @if (!notification.read) {
              <div class="dot"></div>
            }
            @if (!notification.read) {
              <div class="icon icon-notifications-check mark-as-read" (click)="readNotification(notification)"
              ></div>
            }
          </div>
        </div>
      }
    </div>
  }
</div>